import { omit } from 'lodash'

import { CACHE_AUDIO, CACHE_ALL_AUDIO, PURGE_AUDIO } from '../constants/ActionTypes'

/**
 * @type {AudioCache | Null}
 */
const INITIAL_STATE = {}

/**
 * @typedef {import('../types/system').AudioCache} AudioCache
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @param {AudioCache | Null} state
 * @param {PltrAction} action
 * @return {AudioCache | Null}
 */
const audioCacheReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CACHE_AUDIO: {
      const initialisedCache = state ?? {}
      return {
        ...initialisedCache,
        [action.storageUrl]: {
          publicUrl: action.publicUrl,
          timestamp: action.timestamp,
        },
      }
    }
    case CACHE_ALL_AUDIO: {
      const initialisedCache = state ?? {}
      return Object.entries(action.cache).reduce((acc, next) => {
        const [storageUrl, publicUrl] = next
        if (!acc[storageUrl]) {
          return {
            ...acc,
            [storageUrl]: {
              publicUrl,
              timestamp: action.timestamp,
            },
          }
        } else {
          return acc
        }
      }, initialisedCache)
    }
    case PURGE_AUDIO: {
      return omit(state, action.storageUrl)
    }
    default: {
      return state
    }
  }
}

export default audioCacheReducer
